import { LabelAndValue } from 'components/common/LabelAndValue/LabelAndValue';
import { ApplicationPermissions } from '../SubscriptionForm/SubscriptionFormContext';
import { HStack, Text, VStack } from '@montel/montelpro-shared-components-v2';
import { useGlobalContext } from 'components/common/GlobalContext/GlobalContext';
import { BundlePermissions } from 'domain/subscription/interfaces/SubscriptionBundle';
import styled from 'styled-components';

const Parentheses = styled.span`
	color: ${({ theme }) => theme.colors.textSubtle};
`;

export const ApplicationPermissionTabContent: React.FunctionComponent<{
	appPermissions: ApplicationPermissions;
	inheritedPermissions?: BundlePermissions;
}> = ({ appPermissions, inheritedPermissions }) => {
	const { getMinimalAreaRepresentation, getAddonByCode } = useGlobalContext();

	const hasInheritedAreas =
		(inheritedPermissions?.countries?.length ?? 0) > 0;

	const inheritedAddonCodes =
		inheritedPermissions?.applicationPermissions.find(
			(ap) => ap.applicationId === appPermissions.application.id,
		)?.addons ?? [];

	return (
		<HStack gap="4xl">
			<LabelAndValue
				label="Plan"
				value={appPermissions.plan?.displayName}
			/>
			{hasInheritedAreas ? (
				<LabelAndValue
					label="Areas (from bundle)"
					value={
						<VStack gap="xxxs">
							{getMinimalAreaRepresentation(
								appPermissions.application.id,
								inheritedPermissions?.countries ?? [],
							)?.map((area) => (
								<span key={area?.code}>{area?.name}</span>
							))}
						</VStack>
					}
				/>
			) : (
				<LabelAndValue
					label="Areas"
					value={
						<VStack gap="xxxs">
							{getMinimalAreaRepresentation(
								appPermissions.application.id,
								appPermissions.countries?.map((c) => c.code),
							)?.map((area) => (
								<span key={area?.code}>{area?.name}</span>
							))}
						</VStack>
					}
				/>
			)}
			<LabelAndValue
				label="Addons"
				value={
					<VStack gap="xxxs">
						{inheritedAddonCodes.map((code) => {
							const addon = getAddonByCode(
								appPermissions.application.id,
								code,
							);
							return (
								<Text key={code}>
									{addon?.name}{' '}
									<Parentheses>(from bundle)</Parentheses>
								</Text>
							);
						})}
						{appPermissions.addons.map((addon) => (
							<Text key={addon?.code}>{addon?.name}</Text>
						))}
					</VStack>
				}
			/>
		</HStack>
	);
};
